import { useEffect } from 'react';
import { useSocket } from 'sonata-platform-components';

import type { DoohAudienceProfilingOutputData } from 'sonata-static-storage/lib/schemas/doohReport/doohAudienceProfiling.schema';

type DoohAudienceProfilingReadyPayload = {
  lineItemId: string;
  outputData: DoohAudienceProfilingOutputData;
  week: string;
};

type Options = {
  lineItemId: string;
  onReady: (data: DoohAudienceProfilingOutputData) => void;
  week: string | null;
};

/**
 * Waits for the profiling run the endpoint reported as `processing`.
 */
export function useDoohAudienceProfilingSocket({ lineItemId, week, onReady }: Readonly<Options>) {
  const { offEvent, onEvent } = useSocket();

  useEffect(() => {
    if (!week) {
      return;
    }

    const socketKey = `doohAudienceProfiling:${lineItemId}:${week}`;

    onEvent(socketKey, 'doohAudienceProfilingReady', (payload: DoohAudienceProfilingReadyPayload) => {
      if (payload.lineItemId === lineItemId && payload.week === week) {
        onReady(payload.outputData);
      }
    });

    return () => {
      offEvent(socketKey);
    };
  }, [lineItemId, week]);
}
